<template>
    <div>
        <form @submit.prevent="on_submit" id="otp_form">
            <div class="row">
                <div class="col-12 my-2">
                    <div class="h5" v-text="$t('wallets.label.charge_wallet')"></div>
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="amount" v-text="$t('wallets.label.amount_rial')"></label>
                    <input class="form-control" id="amount" name="amount" v-model="form_data.amount">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="pan" v-text="$t('label.pan')"></label>
                    <input class="form-control" id="pan" name="pan" v-model="form_data.pan">
                </div>
                <div class="col-12 mt-4">
                    <button class="btn btn-success" type="submit" v-text="form_meta_data.submit_btn_text"></button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {i18n} from "@/plugins/i18n";

    export default {
        props: {
            form_meta_data: {
                type: Object,
                default: () => {
                    return {
                        submit_btn_progress: false,
                        submit_btn_text: i18n.t('btn.submit'),
                    };
                },
            },
            on_submit: {
                type: Function,
                default: () => {
                },
            },
            form_data: {
                type: Object,
                default: () => {
                    return {};
                },
            },
        },
    }
</script>
